import React, {useEffect, useRef, useState} from 'react';
import Card from "../../../components/card";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../../utils/localization-ag-grid";
import TemplateDefault from "../../../components/template-default";
import SelectComponent from "../../../components/select-component";
import InputDateTime from "../../../components/input-datetime";
import {FaList, FaPrint} from "react-icons/fa";
import Button from "../../../components/button";
import reportService from "../../../services/report-service";
import {useQuery} from "@tanstack/react-query";
import projectService from "../../../services/project-service";
import {toast} from "react-toastify";
import {AlertMessage} from "../../../utils/alert-message";
import moment from "moment";
import {print} from "../components/print";
import "../report.css";

const initialFilters = {
    init: moment().startOf('month').toDate(),
    end: moment().endOf('month').toDate(),
    project: []
}

const ItemsReport = () => {
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState(initialFilters);
    const [filtersStr, setFiltersStr] = useState("");
    const handleSelect = (id, value) => setFilters(prev => ({...prev, [id]: value}));
    const handleInput = (value, name) => setFilters(prev => ({...prev, [name]: value}));
    const [pinnedBottomValues, setPinnedBottomValues] = useState({ action_count: "TOTAL DE AÇÕES EXECUTADAS: 0" });

    useEffect(() => {
        document.title = "SISTEMA INTERNO";
    }, []);

    const [columnDefs, setColumnDefs] = useState([
        {field: "name", headerName: "Ação", flex: 1},
        {field: "action_count", headerName: "Total de vezes executadas", flex: 1},
    ]);

    useEffect(() => {
        setColumnDefs(prevColumnDefs => {
            if (filters.project.length > 0) {
                const hasProject = prevColumnDefs.some(c => c.field === "project");
                return hasProject ? prevColumnDefs : [...prevColumnDefs, {field: "project", headerName: "Projeto", flex: 1}];
            }

            return prevColumnDefs.filter(c => c.field !== "project");
        });

        setData([]);
    }, [filters]);

    const {data: projects} = useQuery({
        queryFn: () => projectService.options().then(({data}) => data),
        queryKey: ["projects"]
    });

    const gridRef = useRef();

    const formatDate = date => {
        if (date) return date.toLocaleDateString() + " " + date.toLocaleTimeString();

        return "";
    }

    useEffect(() => {
        let count = 0;
        for (let item of data) {
            count += parseInt(item.action_count);
        }

        setPinnedBottomValues({action_count: `TOTAL DE AÇÕES EXECUTADAS: ${count}`})
    }, [data]);

    const apply = () => {
        const init = formatDate(filters.init);
        const end = formatDate(filters.end);
        const formData = new FormData();

        formData.append("init", init);
        formData.append("end", end);
        formData.append("project", JSON.stringify(filters.project.map(p => p.value)));

        const filtersStr = `Início: ${init} - Fim: ${end}`;
        setFiltersStr(filtersStr);

        reportService.items(formData)
            .then(({data}) => setData(data))
            .catch((err) => {
                const {data: {message}} = err.response;
                toast.error(AlertMessage[message] ?? "Não foi possível prosseguir.");
            });
    }

    const handlePrint = () => {
        if (gridRef.current) {
            const title = `RELATÓRIO DE UTILIZAÇÃO DE ITEM`;
            const footer = `<tr><td colspan='1'></td><td>${pinnedBottomValues.action_count}</td></tr>`
            print(gridRef, columnDefs, title, filtersStr, footer);
        }
    }

    return (
        <TemplateDefault title="Relatório de utilização de item">
            <Card>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12">
                    <div className={"col-span-2"}>
                        <InputDateTime id={"date-init"} name={"init"} label={"Inicio"} selected={filters.init}
                                       onChange={(value) => handleInput(value, "init")}/>
                    </div>
                    <div className={"col-span-2"}>
                        <InputDateTime id={"date-end"} name={"end"} label={"Fim"} selected={filters.end}
                                       onChange={(value) => handleInput(value, "end")}/>
                    </div>

                    <div className="col-span-4 text-gray-900">
                        <SelectComponent
                            isMulti
                            instanceId="projects"
                            label="Projeto"
                            options={projects ?? []}
                            value={filters.project}
                            onChange={(value) => handleSelect("project", value)}
                            name="projects"
                        />
                    </div>
                    <div className={"hidden lg:block col-span-2"}></div>
                    <Button col={"col-span-1"} onClick={apply}>
                        <FaList/> Aplicar
                    </Button>
                    <Button col={"col-span-1"} onClick={handlePrint}>
                        <FaPrint/>
                    </Button>
                </div>
                <div className={"ag-theme-quartz grid mt-4 report-table"} style={{height: "calc(100vh - 159px)"}}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={32}
                        rowData={data}
                        columnDefs={columnDefs}
                        animateRows={false}
                        suppressRowClickSelection={true}
                        suppressCellFocus={true}
                        gridOptions={{localeText: LocalizationAgGrid}}
                        domLayout='autoHeight'
                        pinnedBottomRowData={[pinnedBottomValues]}
                        getRowStyle={(params) => {
                            if (params.node.rowPinned) {
                                return { pointerEvents: "none", fontWeight: "700"};
                            }
                        }}
                    />
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default ItemsReport;
